// features/audittrail/AuditTrailPanel.jsx

import AuditItem from "./AuditItem";

const AuditTrailPanel = ({
    auditLogs,
    onViewDetails,
    Icon
}) => {

    return (

        <div className="va-sidebar-card">

            <div className="va-sidebar-card__title">

                <Icon name="fa-clock-rotate-left" />

                Audit Trail

                <span className="va-comment-count">
                    {auditLogs.length}
                </span>

            </div>

            <div className="va-audit-list">

                {
                    auditLogs.map(log => (

                        <AuditItem
                            key={log.id}
                            log={log}
                            onViewDetails={
                                onViewDetails
                            }
                        />

                    ))
                }

            </div>

        </div>
    );
};

export default AuditTrailPanel;